import { defineStore } from 'pinia';
import {
  DEFAULT_FILTER_FORM_DATA,
  GroupByDate,
  MgaRealMoneyBalanceListFilter,
  MgaRealMoneyBalanceListFilterFields,
} from '@/models/mga-real-money-balance/mga-real-money-balance-list-filter.model';
import { useMgaReportRealMoneyBalanceListStore } from '@/store/mga-real-money-balance/mga-real-money-balance.store';
import { DEFAULT_OFFSET } from '@/constants';
import { clearObj } from '@marfa/bo-utils';

interface MgaRealMoneyBalanceListFilterStore {
  filterFormData: MgaRealMoneyBalanceListFilter;
  isFilterVisible: boolean;
  activeFiltersCount: number;
  isFilterActive: boolean;
  reportPeriod: GroupByDate;
}

export const useMgaRealMoneyBalanceListFilterStore = defineStore({
  id: 'MgaRealMoneyBalanceListFilterStore',

  state: (): MgaRealMoneyBalanceListFilterStore => ({
    filterFormData: { ...DEFAULT_FILTER_FORM_DATA },
    isFilterVisible: false,
    activeFiltersCount: 1,
    isFilterActive: false,
    reportPeriod: GroupByDate.MONTH,
  }),
  getters: {
    filterFormDataLength: (state) => Object.keys(clearObj(state.filterFormData)).length,
  },
  actions: {
    setFilterVisible(isVisible: boolean): void {
      this.isFilterVisible = isVisible;
    },
    setActiveFiltersCount(count: number): void {
      this.activeFiltersCount = count;
    },
    setReportPeriod(): void {
      this.reportPeriod = this.filterFormData[MgaRealMoneyBalanceListFilterFields.GROUP_BY_DATE];
    },
    setFilterActive(isActive: boolean): void {
      this.isFilterActive = isActive;
    },
    setDefaultFilterFormData(): void {
      this.filterFormData = { ...DEFAULT_FILTER_FORM_DATA };
    },
    toggleFilterVisibility(): void {
      this.setFilterVisible(!this.isFilterVisible);

      if (!this.isFilterActive) {
        this.setDefaultFilterFormData();

        return;
      }

      this.filterFormData[MgaRealMoneyBalanceListFilterFields.GROUP_BY_DATE] = this.reportPeriod;
    },
    submitFilter(): void {
      const { getRealMoneyBalancePlayerList, setCurrentPage, setOffset } = useMgaReportRealMoneyBalanceListStore();

      setCurrentPage(1);
      setOffset(DEFAULT_OFFSET);
      getRealMoneyBalancePlayerList();

      this.setActiveFiltersCount(this.filterFormDataLength);
      this.setFilterActive(true);
      this.setReportPeriod();
      this.toggleFilterVisibility();
    },
    resetFilter(): void {
      const { getRealMoneyBalancePlayerList, setCurrentPage, setOffset } = useMgaReportRealMoneyBalanceListStore();

      this.setDefaultFilterFormData();

      setCurrentPage(1);
      setOffset(DEFAULT_OFFSET);
      getRealMoneyBalancePlayerList();

      this.setActiveFiltersCount(this.filterFormDataLength);
      this.setFilterActive(false);
      this.setReportPeriod();
      this.toggleFilterVisibility();
    },
  },
});
